import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import config from '../config';

const TABS = ['Artists', 'Productions', 'Artist Show History', 'Production Show History', 'Artist Co-Members', 'Projects', 'Shows Map'];

const styles = {
    container: { maxWidth: '1100px', margin: '0 auto', padding: '32px 24px', color: '#e0e0e0', width: '100%', minWidth: 0 },
    profileRow: { display: 'flex', gap: '28px', alignItems: 'flex-start', marginBottom: '32px' },
    avatar: { width: '100px', height: '100px', borderRadius: '50%', objectFit: 'cover', flexShrink: 0 },
    avatarPlaceholder: {
        width: '100px', height: '100px', borderRadius: '50%', backgroundColor: '#2a2a2a',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        color: '#bb86fc', fontWeight: 700, fontSize: '36px', flexShrink: 0
    },
    profileInfo: { flex: 1 },
    name: { fontSize: '30px', fontWeight: 700, color: '#ffffff', margin: '0 0 6px 0' },
    location: { fontSize: '16px', color: '#aaa', marginBottom: '8px' },
    verifiedBadge: { display: 'inline-block', backgroundColor: '#2c2c2c', border: '1px solid #444', borderRadius: '4px', padding: '4px 10px', fontSize: '13px', color: '#4caf50', marginBottom: '8px' },
    unverifiedBadge: { display: 'inline-block', backgroundColor: '#2c2c2c', border: '1px solid #444', borderRadius: '4px', padding: '4px 10px', fontSize: '13px', color: '#e53935', marginBottom: '8px' },
    fka: { fontSize: '14px', color: '#888', fontStyle: 'italic', marginBottom: '6px' },
    bio: { fontSize: '15px', color: '#ccc', lineHeight: '1.7', marginTop: '16px', padding: '16px', backgroundColor: '#1e1e1e', borderRadius: '8px', border: '1px solid #2a2a2a' },
    linksRow: { display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '16px', marginBottom: '8px' },
    linkChip: { backgroundColor: '#1e1e1e', border: '1px solid #444', borderRadius: '4px', padding: '6px 14px', fontSize: '13px', color: '#bb86fc', textDecoration: 'none', fontWeight: 'bold' },
    editBtn: { backgroundColor: 'transparent', border: '1px solid #555', borderRadius: '6px', color: '#aaa', padding: '8px 16px', cursor: 'pointer', fontSize: '13px', textDecoration: 'none', marginTop: '12px', display: 'inline-block' },
    addProductionBtn: { backgroundColor: '#1a3a1a', border: '1px solid #2d6a2d', borderRadius: '6px', color: '#4caf50', padding: '8px 16px', cursor: 'pointer', fontSize: '13px', marginTop: '12px', marginLeft: '8px', display: 'inline-block' },
    tabBar: { display: 'flex', gap: '4px', borderBottom: '2px solid #333', marginBottom: '24px', flexWrap: 'wrap' },
    tab: { padding: '10px 18px', cursor: 'pointer', border: 'none', background: 'none', color: '#aaa', fontSize: '14px', fontWeight: 500, borderBottom: '2px solid transparent', marginBottom: '-2px' },
    tabActive: { color: '#bb86fc', borderBottomColor: '#bb86fc' },
    table: { width: '100%', borderCollapse: 'collapse' },
    th: { textAlign: 'left', padding: '10px 14px', borderBottom: '2px solid #333', color: '#aaa', fontSize: '13px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em' },
    td: { padding: '12px 14px', borderBottom: '1px solid #2a2a2a', fontSize: '12px', verticalAlign: 'middle' },
    link: { color: '#bb86fc', textDecoration: 'none' },
    emptyTab: { color: '#666', padding: '40px 0', textAlign: 'center' },
    badge: { display: 'inline-block', backgroundColor: '#2a2a2a', color: '#aaa', borderRadius: '12px', padding: '2px 10px', fontSize: '13px' },
    rolePill: { display: 'inline-block', backgroundColor: '#1e1240', color: '#bb86fc', borderRadius: '12px', padding: '2px 10px', fontSize: '12px', border: '1px solid #3d2a7a', marginRight: '4px' },
    productionRolePill: { display: 'inline-block', backgroundColor: '#2b1a0d', color: '#ff9800', borderRadius: '12px', padding: '2px 10px', fontSize: '12px', border: '1px solid #7a4200', marginRight: '4px' },
    entityTypeBadge: { display: 'inline-block', borderRadius: '4px', padding: '2px 8px', fontSize: '11px', fontWeight: 600, marginRight: '6px', textTransform: 'uppercase', letterSpacing: '0.05em' },
    coMemberRow: { display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 0', borderBottom: '1px solid #2a2a2a' },
    coAvatar: { width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover' },
    coAvatarPlaceholder: { width: '40px', height: '40px', borderRadius: '50%', backgroundColor: '#2a2a2a', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#bb86fc', fontWeight: 700, fontSize: '16px', flexShrink: 0 },
    mapContainer: { height: '480px', borderRadius: '8px', overflow: 'hidden' },
    tabSearch: { backgroundColor: '#2c2c2c', border: '1px solid #444', borderRadius: '6px', padding: '10px 14px', fontSize: '14px', color: '#e0e0e0', width: '100%', marginBottom: '16px', boxSizing: 'border-box' },
    tableContainer: { overflowX: 'auto' },
    tableLink: { color: '#bb86fc', textDecoration: 'none' },
    trEven: { backgroundColor: '#1e1e1e' },
    trOdd: { backgroundColor: '#1a1a1a' },
    pagination: { display: 'flex', justifyContent: 'center', gap: '6px', marginTop: '20px', flexWrap: 'wrap' },
    pageBtn: { backgroundColor: '#2c2c2c', border: '1px solid #444', borderRadius: '4px', padding: '6px 12px', fontSize: '13px', color: '#aaa', cursor: 'pointer' },
    pageBtnActive: { backgroundColor: '#bb86fc', borderColor: '#bb86fc', color: '#121212', fontWeight: 'bold' },
    pageBtnDisabled: { opacity: 0.35, cursor: 'default' },
    // Productions tab
    entityRow: { borderBottom: '1px solid #2a2a2a' },
    entityRowHeader: { display: 'flex', alignItems: 'center', gap: '12px', padding: '14px', cursor: 'pointer', backgroundColor: '#1a1a1a' },
    entityRowHeaderHover: { backgroundColor: '#222' },
    viewShowsBtn: { backgroundColor: '#2a2a2a', border: '1px solid #444', borderRadius: '4px', padding: '4px 10px', fontSize: '12px', color: '#aaa', cursor: 'pointer', whiteSpace: 'nowrap' },
    expandedShows: { backgroundColor: '#141414', padding: '0 0 8px 0' },
    expandedShowRow: { display: 'grid', gridTemplateColumns: '1fr auto auto', gap: '12px', alignItems: 'center', padding: '10px 20px', borderBottom: '1px solid #1e1e1e', fontSize: '13px' },
    roleInput: { backgroundColor: '#2a2a2a', border: '1px solid #555', borderRadius: '4px', color: '#e0e0e0', padding: '4px 8px', fontSize: '12px', width: '160px' },
    saveBtn: { backgroundColor: '#1a3a1a', border: '1px solid #2d6a2d', borderRadius: '4px', color: '#4caf50', padding: '4px 10px', fontSize: '12px', cursor: 'pointer' },
    removeBtn: { backgroundColor: 'transparent', border: 'none', color: '#cf6679', fontSize: '16px', cursor: 'pointer', padding: '2px 6px', lineHeight: 1 },
    collapsibleSection: { marginBottom: '32px' },
    collapsibleHeader: { width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#1e1e1e', border: '1px solid #333', borderRadius: '8px', padding: '14px 20px', cursor: 'pointer', color: '#e0e0e0' },
    collapsibleTitle: { fontSize: '16px', fontWeight: '600' },
    collapsibleChevron: { fontSize: '12px', color: '#888' },
    collapsibleBody: { backgroundColor: '#1a1a1a', border: '1px solid #333', borderTop: 'none', borderRadius: '0 0 8px 8px', padding: '20px' },
    photosEmpty: { textAlign: 'center', color: '#666', padding: '20px 0', fontSize: '14px' },
    uploadLink: { backgroundColor: '#bb86fc', color: '#121212', borderRadius: '6px', padding: '7px 16px', fontSize: '13px', fontWeight: '600', textDecoration: 'none' },
    photoGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: '12px' },
    photoCard: { backgroundColor: '#1e1e1e', border: '1px solid #333', borderRadius: '8px', overflow: 'hidden' },
    photoThumb: { position: 'relative', width: '100%', paddingTop: '75%', overflow: 'hidden', cursor: 'zoom-in', background: '#111' },
    photoThumbImg: { position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover' },
    privateBadge: { position: 'absolute', top: '6px', right: '6px', background: 'rgba(0,0,0,0.6)', borderRadius: '4px', padding: '2px 4px', fontSize: '12px' },
    photoCardBody: { padding: '8px' },
    photoCaption: { fontSize: '11px', color: '#aaa', marginBottom: '6px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' },
    setDefaultBtn: { width: '100%', background: 'transparent', border: '1px solid #bb86fc', borderRadius: '4px', color: '#bb86fc', fontSize: '11px', padding: '4px 6px', cursor: 'pointer' },
    removeDefaultBtn: { background: 'transparent', border: '1px solid #555', borderRadius: '6px', color: '#aaa', padding: '8px 12px', fontSize: '12px', cursor: 'pointer', whiteSpace: 'nowrap', flexShrink: 0 },
    defaultBadge: { position: 'absolute', top: '6px', left: '6px', background: '#bb86fc', color: '#121212', fontSize: '10px', fontWeight: 'bold', borderRadius: '4px', padding: '2px 6px' },
    lightboxOverlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 3000 },
    lightboxCaption: { position: 'absolute', bottom: 0, left: 0, right: 0, background: 'rgba(0,0,0,0.7)', color: '#e0e0e0', padding: '8px 12px', fontSize: '13px', textAlign: 'center', borderRadius: '0 0 8px 8px' },
    lightboxClose: { position: 'absolute', top: '8px', right: '8px', background: 'rgba(0,0,0,0.6)', border: 'none', color: '#fff', fontSize: '18px', cursor: 'pointer', borderRadius: '4px', padding: '2px 8px' },
};

const PAGE_SIZE = 25;

// ── helpers ───────────────────────────────────────────────────────────────────
function formatDate(dateStr) {
    if (!dateStr) return '—';
    return new Date(dateStr).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
}

function entityLink(type, slug, name) {
    const pathMap = { Artist: 'artists', Festival: 'festivals', Promoter: 'promoters', Venue: 'venues' };
    const path = pathMap[type];
    if (!path || !slug) return name;
    return <Link to={`/${path}/${slug}`} style={styles.tableLink}>{name}</Link>;
}

function Pagination({ currentPage, totalItems, onPageChange }) {
    const totalPages = Math.ceil(totalItems / PAGE_SIZE);
    if (totalPages <= 1) return null;
    const pages = [];
    for (let i = 1; i <= totalPages; i++) pages.push(i);
    return (
        <div style={styles.pagination}>
            <button onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}
                style={{ ...styles.pageBtn, ...(currentPage === 1 ? styles.pageBtnDisabled : {}) }}>‹ Prev</button>
            {pages.map(p => (
                <button key={p} onClick={() => onPageChange(p)}
                    style={{ ...styles.pageBtn, ...(p === currentPage ? styles.pageBtnActive : {}) }}>{p}</button>
            ))}
            <button onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages}
                style={{ ...styles.pageBtn, ...(currentPage === totalPages ? styles.pageBtnDisabled : {}) }}>Next ›</button>
        </div>
    );
}

// ── ProjectsTab ────────────────────────────────────────────────────────────────
function ProjectsTab({ projects }) {
    if (!projects || projects.length === 0) {
        return (
            <div style={{ textAlign: 'center', padding: '20px 0' }}>
                <div style={{ color: '#666', fontSize: '14px', marginBottom: '12px' }}>No projects yet.</div>
                <a href="/add-project" style={{ color: '#bb86fc', fontSize: '13px', textDecoration: 'none' }}>+ Start a Project</a>
            </div>
        );
    }
    return (
        <div>
            {projects.map(p => (
                <div key={p.id} style={{ marginBottom: '16px', paddingBottom: '16px', borderBottom: '1px solid #2a2a2a' }}>
                    <div style={{ marginBottom: '6px' }}>
                        <a href={`/projects/${p.id}`} style={{ color: '#bb86fc', textDecoration: 'none', fontWeight: '600', fontSize: '14px' }}>{p.name}</a>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div style={{ flex: 1, height: '8px', backgroundColor: '#2c2c2c', borderRadius: '4px', overflow: 'hidden', maxWidth: '200px' }}>
                            <div style={{ width: `${Math.min(p.pct_complete, 100)}%`, height: '100%', backgroundColor: '#bb86fc', borderRadius: '4px' }} />
                        </div>
                        <span style={{ fontSize: '12px', color: '#bb86fc', fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                            {p.pct_complete > 100 ? '100+%' : `${p.pct_complete}%`}
                        </span>
                        <span style={{ fontSize: '12px', color: '#555' }}>{p.actual_value} / {p.estimated_value} shows</span>
                    </div>
                    <div style={{ fontSize: '12px', color: '#555', marginTop: '4px' }}>{p.metric} · {p.date_start} to {p.date_end}</div>
                </div>
            ))}
        </div>
    );
}

// ── ArtistsTab (unchanged) ────────────────────────────────────────────────────
function ArtistsTab({ artists }) {
    if (!artists || artists.length === 0) return <div style={styles.emptyTab}>No artist associations found.</div>;
    return (
        <table style={styles.table}>
            <thead>
                <tr>
                    <th style={styles.th}>Artist</th>
                    <th style={styles.th}>Role(s)</th>
                    <th style={styles.th}>Shows</th>
                    <th style={styles.th}>First Show</th>
                    <th style={styles.th}>Last Show</th>
                </tr>
            </thead>
            <tbody>
                {artists.map(a => (
                    <tr key={a.id}>
                        <td style={styles.td}><Link to={`/artists/${a.slug}`} style={styles.link}>{a.name}</Link></td>
                        <td style={styles.td}>
                            {a.roles ? a.roles.split(', ').map((r, i) => <span key={i} style={styles.rolePill}>{r}</span>) : <span style={{ color: '#555' }}>—</span>}
                        </td>
                        <td style={styles.td}><span style={styles.badge}>{a.show_count}</span></td>
                        <td style={styles.td}>{formatDate(a.first_show)}</td>
                        <td style={styles.td}>{formatDate(a.last_show)}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}

// ── ProductionsTab ────────────────────────────────────────────────────────────
function ProductionsTab({ productions, memberId, onProductionUpdated }) {
    const [expandedEntity, setExpandedEntity] = useState(null);
    const [editingId, setEditingId] = useState(null);
    const [editRole, setEditRole] = useState('');
    const [saving, setSaving] = useState(false);
    const [removing, setRemoving] = useState(null);

    if (!productions || productions.length === 0) {
        return <div style={styles.emptyTab}>No production roles recorded yet.</div>;
    }

    const toggleExpand = (key) => setExpandedEntity(prev => prev === key ? null : key);

    const handleEditStart = (show) => {
        setEditingId(show.production_role_id);
        setEditRole(show.role);
    };

    const handleSave = async (show) => {
        if (!editRole.trim()) return;
        setSaving(true);
        try {
            const { getIdToken } = await import('../attendedUtils');
            const token = await getIdToken();
            await axios.put(
                `${config.API_URL}/members/${memberId}/production-roles/${show.production_role_id}`,
                { role: editRole.trim() },
                { headers: { Authorization: token } }
            );
            setEditingId(null);
            onProductionUpdated();
        } catch (err) {
            console.error('Failed to update role', err);
        } finally {
            setSaving(false);
        }
    };

    const handleRemove = async (show) => {
        if (!window.confirm(`Remove production role "${show.role}" at ${show.venue_name} on ${formatDate(show.event_date)}?`)) return;
        setRemoving(show.production_role_id);
        try {
            const { getIdToken } = await import('../attendedUtils');
            const token = await getIdToken();
            await axios.delete(
                `${config.API_URL}/members/${memberId}/production-roles/${show.production_role_id}`,
                { headers: { Authorization: token } }
            );
            onProductionUpdated();
        } catch (err) {
            console.error('Failed to remove role', err);
        } finally {
            setRemoving(null);
        }
    };

    return (
        <div>
            <table style={styles.table}>
                <thead>
                    <tr>
                        <th style={styles.th}>Entity</th>
                        <th style={styles.th}>Role(s)</th>
                        <th style={styles.th}># Shows</th>
                        <th style={styles.th}>First Show</th>
                        <th style={styles.th}>Last Show</th>
                        <th style={styles.th}></th>
                    </tr>
                </thead>
                <tbody>
                    {productions.map(entity => {
                        const key = `${entity.entity_type}-${entity.entity_id}`;
                        const isExpanded = expandedEntity === key;
                        return (
                            <React.Fragment key={key}>
                                <tr style={styles.trOdd}>
                                    <td style={styles.td}>
                                        {entityLink(entity.entity_type, entity.entity_slug, entity.entity_name)}
                                    </td>
                                    <td style={styles.td}>
                                        {entity.roles
                                            ? entity.roles.split(', ').map((r, i) => <span key={i} style={styles.productionRolePill}>{r}</span>)
                                            : <span style={{ color: '#555' }}>—</span>}
                                    </td>
                                    <td style={styles.td}><span style={styles.badge}>{entity.show_count}</span></td>
                                    <td style={styles.td}>{formatDate(entity.first_show)}</td>
                                    <td style={styles.td}>{formatDate(entity.last_show)}</td>
                                    <td style={styles.td}>
                                        <button
                                            style={styles.viewShowsBtn}
                                            onClick={() => toggleExpand(key)}
                                        >
                                            {isExpanded ? 'Hide Shows ▲' : 'View Shows ▼'}
                                        </button>
                                    </td>
                                </tr>
                                {isExpanded && entity.shows && entity.shows.map(show => (
                                    <tr key={show.production_role_id} style={{ backgroundColor: '#141414' }}>
                                        <td colSpan={6} style={{ padding: '0' }}>
                                            <div style={{ display: 'grid', gridTemplateColumns: '160px 1fr auto auto', gap: '12px', alignItems: 'center', padding: '10px 20px', borderBottom: '1px solid #1e1e1e', fontSize: '13px' }}>
                                                <span style={{ color: '#aaa', whiteSpace: 'nowrap' }}>{formatDate(show.event_date)}</span>
                                                <span>
                                                    {show.venue_slug
                                                        ? <Link to={`/venues/${show.venue_slug}`} style={styles.tableLink}>{show.venue_name}</Link>
                                                        : show.venue_name}
                                                    {show.city && <span style={{ color: '#666', marginLeft: '6px' }}>· {[show.city, show.state, show.country].filter(Boolean).join(', ')}</span>}
                                                </span>
                                                {editingId === show.production_role_id ? (
                                                    <>
                                                        <input
                                                            style={styles.roleInput}
                                                            value={editRole}
                                                            onChange={e => setEditRole(e.target.value)}
                                                            onKeyDown={e => e.key === 'Enter' && handleSave(show)}
                                                            autoFocus
                                                        />
                                                        <div style={{ display: 'flex', gap: '6px' }}>
                                                            <button style={styles.saveBtn} onClick={() => handleSave(show)} disabled={saving}>
                                                                {saving ? '...' : 'Save'}
                                                            </button>
                                                            <button style={{ ...styles.saveBtn, backgroundColor: '#2a2a2a', border: '1px solid #444', color: '#aaa' }} onClick={() => setEditingId(null)}>
                                                                Cancel
                                                            </button>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        <span style={styles.productionRolePill}>{show.role}</span>
                                                        <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                                                            <button style={styles.viewShowsBtn} onClick={() => handleEditStart(show)}>Edit</button>
                                                            <button
                                                                style={styles.removeBtn}
                                                                onClick={() => handleRemove(show)}
                                                                disabled={removing === show.production_role_id}
                                                                title="Remove production role"
                                                            >
                                                                {removing === show.production_role_id ? '...' : '✕'}
                                                            </button>
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </React.Fragment>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}

// ── ArtistShowHistoryTab (renamed + role column added) ────────────────────────
function ArtistShowHistoryTab({ shows }) {
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState('');

    if (!shows || shows.length === 0) return <div style={styles.emptyTab}>No shows recorded yet.</div>;

    const q = search.toLowerCase();
    const filtered = search ? shows.filter(s => {
        const dateStr = formatDate(s.event_date);
        return [dateStr, s.city, s.state, s.country, s.venue_name, s.other_artists, s.festival_name, s.member_of_names, s.artist_roles]
            .some(val => val && val.toLowerCase().includes(q));
    }) : shows;

    const totalShows = shows.length;
    const paginated = filtered.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

    return (
        <div>
            <input
                type="text"
                placeholder="Search by date, city, state, country, venue, artist, role..."
                value={search}
                onChange={e => { setSearch(e.target.value); setPage(1); }}
                style={styles.tabSearch}
            />
            {filtered.length === 0 ? (
                <div style={styles.emptyTab}>No shows match your search.</div>
            ) : (
                <>
                    <div style={styles.tableContainer}>
                        <table style={styles.table}>
                            <thead>
                                <tr>
                                    <th style={styles.th}>Show #</th>
                                    <th style={styles.th}>Date</th>
                                    <th style={styles.th}>Artist</th>
                                    <th style={styles.th}>Role(s)</th>
                                    <th style={styles.th}>City</th>
                                    <th style={styles.th}>State</th>
                                    <th style={styles.th}>Country</th>
                                    <th style={styles.th}>Venue</th>
                                    <th style={styles.th}>Artists</th>
                                </tr>
                            </thead>
                            <tbody>
                                {paginated.map((s, idx) => {
                                    const globalIdx = shows.indexOf(s);
                                    const showNum = totalShows - globalIdx;
                                    return (
                                        <tr key={s.event_id} style={idx % 2 === 0 ? styles.trEven : styles.trOdd}>
                                            <td style={{ ...styles.td, fontWeight: 'bold' }}>
                                                <Link to={`/events/${s.event_slug}`} style={styles.tableLink}>{showNum}</Link>
                                            </td>
                                            <td style={{ ...styles.td, whiteSpace: 'nowrap' }}>{formatDate(s.event_date)}</td>
                                            <td style={styles.td}>
                                                {s.member_of_names
                                                    ? s.member_of_names.split(', ').map((name, i) => {
                                                        const slugs = s.member_of_slugs ? s.member_of_slugs.split('|') : [];
                                                        const slug = slugs[i];
                                                        return slug
                                                            ? <React.Fragment key={i}>{i > 0 && ', '}<Link to={`/artists/${slug}`} style={styles.tableLink}>{name}</Link></React.Fragment>
                                                            : <React.Fragment key={i}>{i > 0 && ', '}{name}</React.Fragment>;
                                                    })
                                                    : '—'}
                                            </td>
                                            <td style={styles.td}>
                                                {s.artist_roles
                                                    ? s.artist_roles.split(', ').map((r, i) => <span key={i} style={styles.rolePill}>{r}</span>)
                                                    : <span style={{ color: '#555' }}>—</span>}
                                            </td>
                                            <td style={styles.td}>{s.city || '—'}</td>
                                            <td style={styles.td}>{s.state || '—'}</td>
                                            <td style={styles.td}>{s.country || '—'}</td>
                                            <td style={styles.td}>
                                                {s.venue_slug
                                                    ? <Link to={`/venues/${s.venue_slug}`} style={styles.tableLink}>{s.venue_name}</Link>
                                                    : s.venue_name || '—'}
                                            </td>
                                            <td style={{ ...styles.td, color: '#aaa' }}>
                                                {s.festival_name && s.festival_slug
                                                    ? <><Link to={`/festivals/${s.festival_slug}`} style={{ color: '#bb86fc', textDecoration: 'none', fontWeight: 'bold' }}>{s.festival_name}</Link>{s.other_artists ? ` - ${s.other_artists}` : ''}</>
                                                    : s.other_artists || '—'}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                    <Pagination currentPage={page} totalItems={filtered.length} onPageChange={setPage} />
                </>
            )}
        </div>
    );
}

// ── ProductionShowHistoryTab ───────────────────────────────────────────────────
function ProductionShowHistoryTab({ shows }) {
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState('');

    if (!shows || shows.length === 0) return <div style={styles.emptyTab}>No production show history yet.</div>;

    const q = search.toLowerCase();
    const filtered = search ? shows.filter(s => {
        const dateStr = formatDate(s.event_date);
        return [dateStr, s.entity_name, s.entity_type, s.role, s.city, s.state, s.country, s.venue_name, s.artists]
            .some(val => val && val.toLowerCase().includes(q));
    }) : shows;

    const totalShows = shows.length;
    const paginated = filtered.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

    return (
        <div>
            <input
                type="text"
                placeholder="Search by date, entity, role, city, venue, artists..."
                value={search}
                onChange={e => { setSearch(e.target.value); setPage(1); }}
                style={styles.tabSearch}
            />
            {filtered.length === 0 ? (
                <div style={styles.emptyTab}>No shows match your search.</div>
            ) : (
                <>
                    <div style={styles.tableContainer}>
                        <table style={styles.table}>
                            <thead>
                                <tr>
                                    <th style={styles.th}>Show #</th>
                                    <th style={styles.th}>Date</th>
                                    <th style={styles.th}>Entity</th>
                                    <th style={styles.th}>Role(s)</th>
                                    <th style={styles.th}>City</th>
                                    <th style={styles.th}>State</th>
                                    <th style={styles.th}>Country</th>
                                    <th style={styles.th}>Venue</th>
                                    <th style={styles.th}>Artists</th>
                                </tr>
                            </thead>
                            <tbody>
                                {paginated.map((s, idx) => {
                                    const globalIdx = shows.indexOf(s);
                                    const showNum = totalShows - globalIdx;
                                    return (
                                        <tr key={s.production_role_id} style={idx % 2 === 0 ? styles.trEven : styles.trOdd}>
                                            <td style={{ ...styles.td, fontWeight: 'bold' }}>
                                                <Link to={`/events/${s.event_slug}`} style={styles.tableLink}>{showNum}</Link>
                                            </td>
                                            <td style={{ ...styles.td, whiteSpace: 'nowrap' }}>{formatDate(s.event_date)}</td>
                                            <td style={styles.td}>
                                                {entityLink(s.entity_type, s.entity_slug, s.entity_name)}
                                            </td>
                                            <td style={styles.td}>
                                                <span style={styles.productionRolePill}>{s.role}</span>
                                            </td>
                                            <td style={styles.td}>{s.city || '—'}</td>
                                            <td style={styles.td}>{s.state || '—'}</td>
                                            <td style={styles.td}>{s.country || '—'}</td>
                                            <td style={styles.td}>
                                                {s.venue_slug
                                                    ? <Link to={`/venues/${s.venue_slug}`} style={styles.tableLink}>{s.venue_name}</Link>
                                                    : s.venue_name || '—'}
                                            </td>
                                            <td style={{ ...styles.td, color: '#aaa' }}>
                                                {s.festival_name && s.festival_slug
                                                    ? <><Link to={`/festivals/${s.festival_slug}`} style={{ color: '#bb86fc', textDecoration: 'none', fontWeight: 'bold' }}>{s.festival_name}</Link>{s.artists ? ` - ${s.artists}` : ''}</>
                                                    : s.artists || '—'}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                    <Pagination currentPage={page} totalItems={filtered.length} onPageChange={setPage} />
                </>
            )}
        </div>
    );
}

// ── ArtistCoMembersTab (renamed from CoMembersTab, content unchanged) ─────────
function ArtistCoMembersTab({ coMembers }) {
    if (!coMembers || coMembers.length === 0) return <div style={styles.emptyTab}>No co-members found yet.</div>;
    return (
        <div>
            {coMembers.map(m => (
                <div key={m.id} style={styles.coMemberRow}>
                    {m.image_url
                        ? <img src={m.image_url} alt={m.name} style={styles.coAvatar} />
                        : <div style={styles.coAvatarPlaceholder}>{m.name.charAt(0).toUpperCase()}</div>
                    }
                    <div style={{ flex: 1 }}>
                        <Link to={`/members/${m.slug}`} style={{ ...styles.link, fontWeight: 600 }}>{m.name}</Link>
                        <div style={{ marginTop: '3px' }}>
                            {m.roles && m.roles.split(', ').map((r, i) => <span key={i} style={styles.rolePill}>{r}</span>)}
                        </div>
                    </div>
                    <span style={styles.badge}>{m.shows_together} show{m.shows_together !== 1 ? 's' : ''} together</span>
                </div>
            ))}
        </div>
    );
}

// ── ShowsMapTab (unchanged) ───────────────────────────────────────────────────
function ShowsMapTab({ showMap }) {
    const mapRef = React.useRef(null);
    const mapInstanceRef = React.useRef(null);
    const [leafletReady, setLeafletReady] = React.useState(!!window.L);

    React.useEffect(() => {
        if (window.L) { setLeafletReady(true); return; }
        if (!document.getElementById('leaflet-css')) {
            const link = document.createElement('link');
            link.id = 'leaflet-css';
            link.rel = 'stylesheet';
            link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
            document.head.appendChild(link);
        }
        const script = document.createElement('script');
        script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
        script.onload = () => setLeafletReady(true);
        document.head.appendChild(script);
    }, []);

    React.useEffect(() => {
        if (!leafletReady || !mapRef.current || !showMap || showMap.length === 0) return;
        if (mapInstanceRef.current) { mapInstanceRef.current.remove(); mapInstanceRef.current = null; }
        const L = window.L;
        const map = L.map(mapRef.current, { zoomControl: true });
        mapInstanceRef.current = map;

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '© OpenStreetMap contributors', maxZoom: 18,
        }).addTo(map);

        const markerIcon = L.divIcon({
            className: '',
            html: `<div style="width:12px;height:12px;background:#bb86fc;border-radius:50%;border:2px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,0.5);"></div>`,
            iconSize: [12, 12], iconAnchor: [6, 6], popupAnchor: [0, -8],
        });

        const bounds = [];
        showMap.forEach(venue => {
            const lat = parseFloat(venue.lat);
            const lng = parseFloat(venue.lng);
            if (isNaN(lat) || isNaN(lng)) return;
            bounds.push([lat, lng]);
            const dates = venue.show_dates
                ? venue.show_dates.split(',').map(d => {
                    const dt = new Date(d.trim());
                    return dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
                }) : [];
            const locationStr = [venue.city, venue.state, venue.country].filter(Boolean).join(', ');
            const showCount = parseInt(venue.show_count);
            const popupHtml = `
                <div style="font-family:sans-serif;min-width:180px;max-width:260px;">
                    <div style="font-weight:bold;font-size:14px;margin-bottom:4px;">
                        <a href="/venues/${venue.venue_slug}" style="color:#bb86fc;text-decoration:none;">${venue.venue_name} ↗</a>
                    </div>
                    ${locationStr ? `<div style="font-size:12px;color:#888;margin-bottom:6px;">${locationStr}</div>` : ''}
                    <div style="font-size:12px;color:#aaa;">
                        <strong style="color:#e0e0e0;">${showCount}</strong> show${showCount !== 1 ? 's' : ''}
                    </div>
                    ${dates.length > 0 ? `<div style="font-size:11px;color:#999;line-height:1.6;margin-top:6px;">${dates.slice(0, 10).join('<br/>')}${dates.length > 10 ? `<br/><em>+${dates.length - 10} more</em>` : ''}</div>` : ''}
                </div>`;
            L.marker([lat, lng], { icon: markerIcon }).bindPopup(popupHtml, { maxWidth: 280 }).addTo(map);
        });

        if (bounds.length === 1) { map.setView(bounds[0], 12); }
        else if (bounds.length > 1) { map.fitBounds(bounds, { padding: [40, 40] }); }

        return () => { if (mapInstanceRef.current) { mapInstanceRef.current.remove(); mapInstanceRef.current = null; } };
    }, [leafletReady, showMap]);

    if (!showMap || showMap.length === 0) return <div style={styles.emptyTab}>No geocoded venues found.</div>;

    return (
        <div>
            <div style={{ marginBottom: '12px', fontSize: '13px', color: '#888' }}>
                {showMap.length} venue{showMap.length !== 1 ? 's' : ''} with location data · Click a pin for details
            </div>
            {!leafletReady
                ? <div style={styles.emptyTab}>Loading map...</div>
                : <div ref={mapRef} style={{ height: '480px', borderRadius: '8px', border: '1px solid #333', overflow: 'hidden' }} />
            }
        </div>
    );
}

// ── Main Component ────────────────────────────────────────────────────────────
export default function MemberDetail() {
    const { slug } = useParams();
    const navigate = useNavigate();
    const [data, setData] = useState(null);
    const [activeTab, setActiveTab] = useState('Artists');
    const [photosOpen, setPhotosOpen] = useState(false);
    const [photos, setPhotos] = useState([]);
    const [photosLoading, setPhotosLoading] = useState(false);
    const [photosError, setPhotosError] = useState('');
    const [photosLoaded, setPhotosLoaded] = useState(false);
    const [lightbox, setLightbox] = useState(null);
    const [defaultImageId, setDefaultImageId] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const loadData = () => {
        setLoading(true);
        axios.get(`${config.API_URL}/members/${slug}`)
            .then(res => {
                setData(res.data);
                if (res.data?.member?.default_image_id) {
                    setDefaultImageId(res.data.member.default_image_id);
                }
            })
            .catch(() => setError('Member not found.'))
            .finally(() => setLoading(false));
    };

    useEffect(() => { loadData(); }, [slug]); // eslint-disable-line react-hooks/exhaustive-deps

    const togglePhotos = async () => {
        const opening = !photosOpen;
        setPhotosOpen(opening);
        if (opening && !photosLoaded && data) {
            setPhotosLoading(true);
            try {
                const { getIdToken } = await import('../attendedUtils');
                const token = await getIdToken();
                const res = await axios.get(`${config.API_URL}/images`, {
                    params: { entityType: 'member', entityId: data.member.id },
                    headers: { Authorization: token },
                });
                setPhotos(res.data.images || []);
                setPhotosLoaded(true);
            } catch {
                setPhotosError('Failed to load photos.');
            } finally {
                setPhotosLoading(false);
            }
        }
    };

    const handleSetDefault = async (image) => {
        try {
            const { getIdToken } = await import('../attendedUtils');
            const token = await getIdToken();
            await axios.post(
                `${config.API_URL}/images/set-default`,
                { imageId: image.id, entityType: 'member', entityId: data.member.id },
                { headers: { Authorization: token } }
            );
            setDefaultImageId(image.id);
        } catch (e) {
            alert(e.response?.data?.error || 'Failed to set default image.');
        }
    };

    const handleRemoveDefault = async () => {
        try {
            const { getIdToken } = await import('../attendedUtils');
            const token = await getIdToken();
            await axios.post(
                `${config.API_URL}/images/set-default`,
                { imageId: null, entityType: 'member', entityId: data.member.id },
                { headers: { Authorization: token } }
            );
            setDefaultImageId(null);
        } catch (e) {
            alert(e.response?.data?.error || 'Failed to remove default image.');
        }
    };

    if (loading) return <div style={{ color: '#e0e0e0', padding: '40px', textAlign: 'center' }}>Loading...</div>;
    if (error || !data) return <div style={{ color: '#cf6679', padding: '40px', textAlign: 'center' }}>{error || 'Member not found.'}</div>;

    const { member, links, artists, show_history, co_members, show_map, productions, production_show_history } = data;

    const handleAddProductionRole = () => {
        navigate(`/production-role-mapping/${member.id}`);
    };

    return (
        <div style={styles.container}>
            <div style={styles.profileRow}>
                {member.image_url
                    ? <img src={member.image_url} alt={member.name} style={styles.avatar} />
                    : <div style={styles.avatarPlaceholder}>{member.name.charAt(0).toUpperCase()}</div>
                }
                <div style={styles.profileInfo}>
                    <h1 style={styles.name}>{member.name}</h1>

                    {[member.city, member.state_code, member.country_code].filter(Boolean).length > 0 && (
                        <div style={styles.location}>
                            {[member.city, member.state_code, member.country_code].filter(Boolean).join(', ')}
                        </div>
                    )}

                    {member.sharc_id ? (
                        <span style={styles.verifiedBadge}>✔ Verified</span>
                    ) : (
                        <span style={styles.unverifiedBadge}>Unverified</span>
                    )}

                    {(member.hometown_city || member.hometown_state || member.hometown_country) && (
                        <div style={styles.fka}>
                            Hometown: {[member.hometown_city, member.hometown_state, member.hometown_country].filter(Boolean).join(', ')}
                        </div>
                    )}

                    {member.bio && <div style={styles.bio}>{member.bio}</div>}

                    {links && links.length > 0 && (
                        <div style={styles.linksRow}>
                            {links.map((l, i) => (
                                <a key={i} href={l.url} target="_blank" rel="noopener noreferrer" style={styles.linkChip}>{l.description} ↗</a>
                            ))}
                        </div>
                    )}

                    <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginTop: '12px' }}>
                        <Link to={`/members/${slug}/edit`} style={styles.editBtn}>Edit Member</Link>
                        <button onClick={handleAddProductionRole} style={styles.addProductionBtn}>+ Add Production Role</button>
                    </div>
                </div>
            </div>

            {/* Photos — collapsible */}
            <div style={styles.collapsibleSection}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <button onClick={togglePhotos} style={{ ...styles.collapsibleHeader, flex: 1 }}>
                        <span style={styles.collapsibleTitle}>📷 Photos</span>
                        <span style={styles.collapsibleChevron}>{photosOpen ? '▲' : '▼'}</span>
                    </button>
                    {defaultImageId && (
                        <button onClick={handleRemoveDefault} style={styles.removeDefaultBtn}>
                            ✕ Remove Default
                        </button>
                    )}
                </div>
                {photosOpen && (
                    <div style={styles.collapsibleBody}>
                        {photosLoading && <div style={styles.photosEmpty}>Loading photos…</div>}
                        {photosError && <div style={styles.photosEmpty}>{photosError}</div>}
                        {!photosLoading && !photosError && photos.length === 0 && (
                            <div style={{ textAlign: 'center', padding: '20px 0' }}>
                                <div style={{ fontSize: '28px', marginBottom: '8px' }}>📷</div>
                                <div style={{ color: '#666', fontSize: '14px', marginBottom: '12px' }}>No photos yet for this member.</div>
                                <a href="/my-images" style={styles.uploadLink}>+ Upload a Photo</a>
                                <div style={{ color: '#555', fontSize: '12px', marginTop: '8px' }}>After uploading, assign it to this member using ID #{member.id}</div>
                            </div>
                        )}
                        {!photosLoading && photos.length > 0 && (
                            <div style={styles.photoGrid}>
                                {photos.map(img => {
                                    const isDefault = img.id === defaultImageId;
                                    return (
                                        <div key={img.id} style={{ ...styles.photoCard, ...(isDefault ? { borderColor: '#bb86fc' } : {}) }}>
                                            <div style={styles.photoThumb} onClick={() => setLightbox(img)}>
                                                <img src={img.image_url} alt={img.caption || ''} style={styles.photoThumbImg} loading="lazy" />
                                                {isDefault && <span style={styles.defaultBadge}>★ Default</span>}
                                                {!img.is_public && <span style={styles.privateBadge}>🔒</span>}
                                        </div>
                                        <div style={styles.photoCardBody}>
                                            {img.caption && <div style={styles.photoCaption}>{img.caption}</div>}
                                            {img.is_public && !isDefault && (
                                                <button onClick={() => handleSetDefault(img)} style={styles.setDefaultBtn}>
                                                    ★ Set as Default
                                                </button>
                                            )}
                                            {isDefault && <div style={{ fontSize: '11px', color: '#bb86fc', textAlign: 'center', padding: '4px 0' }}>Current default</div>}
                                        </div>
                                    </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                )}
            </div>

            {/* Lightbox */}
            {lightbox && (
                <div style={styles.lightboxOverlay} onClick={() => setLightbox(null)}>
                    <div style={{ position: 'relative' }}>
                        <img src={lightbox.image_url} alt={lightbox.caption || ''} style={{ maxWidth: '90vw', maxHeight: '85vh', objectFit: 'contain', borderRadius: '8px' }} />
                        {lightbox.caption && <div style={styles.lightboxCaption}>{lightbox.caption}</div>}
                        <button onClick={() => setLightbox(null)} style={styles.lightboxClose}>✕</button>
                    </div>
                </div>
            )}

            <div style={styles.tabBar}>
                {TABS.map(tab => (
                    <button
                        key={tab}
                        style={{ ...styles.tab, ...(activeTab === tab ? styles.tabActive : {}) }}
                        onClick={() => setActiveTab(tab)}
                    >
                        {tab}
                        {tab === 'Artists' && <span style={{ ...styles.badge, marginLeft: '6px' }}>{artists.length}</span>}
                        {tab === 'Productions' && <span style={{ ...styles.badge, marginLeft: '6px' }}>{(productions || []).length}</span>}
                        {tab === 'Artist Show History' && <span style={{ ...styles.badge, marginLeft: '6px' }}>{show_history.length}</span>}
                        {tab === 'Production Show History' && <span style={{ ...styles.badge, marginLeft: '6px' }}>{(production_show_history || []).length}</span>}
                        {tab === 'Artist Co-Members' && <span style={{ ...styles.badge, marginLeft: '6px' }}>{co_members.length}</span>}
                    </button>
                ))}
            </div>

            <div style={{ width: '100%', minWidth: 0, boxSizing: 'border-box' }}>
                {activeTab === 'Artists' && <ArtistsTab artists={artists} />}
                {activeTab === 'Productions' && (
                    <ProductionsTab
                        productions={productions || []}
                        memberId={member.id}
                        onProductionUpdated={loadData}
                    />
                )}
                {activeTab === 'Artist Show History' && <ArtistShowHistoryTab shows={show_history} />}
                {activeTab === 'Production Show History' && <ProductionShowHistoryTab shows={production_show_history || []} />}
                {activeTab === 'Artist Co-Members' && <ArtistCoMembersTab coMembers={co_members} />}
                {activeTab === 'Projects' && <ProjectsTab projects={data.projects} entityType="member" />}
                {activeTab === 'Shows Map' && <ShowsMapTab showMap={show_map} />}
            </div>
        </div>
    );
}
